import api from "../api/api";

export const QuizService = {
  // Mağazanın aktiv kampaniyaları
  merchantQuizzes: async (merchantId) => {
    const response = await api.get("quizzes", {
      params: { merchant_id: merchantId },
    });
    return response.data; // { quizzes: [...] }
  },

  // Sessiya başlat — login varsa customer sessiyası, yoxdursa guest_token qaytarılır
  start: async ({ merchantId, quizId, channel = "qr" }) => {
    const response = await api.post("quiz-sessions", {
      merchant_id: merchantId,
      quiz_id: quizId,
      channel,
    });
    return response.data; // { session_id, guest_token, quiz, questions }
  },

  // Bütün cavabları göndər (qonaq üçün guest_token mütləqdir)
  submit: async ({ sessionId, answers, guestToken = null }) => {
    const payload = { answers };
    if (guestToken) payload.guest_token = guestToken;
    const response = await api.post(
      `quiz-sessions/${sessionId}/answers`,
      payload
    );
    return response.data; // { score_pct, correct, total, coupon, requires_registration, reward_preview }
  },

  // Qeydiyyatdan sonra qonaq sessiyasını hesaba bağla → kupon
  claim: async ({ sessionId, guestToken }) => {
    const response = await api.post(`quiz-sessions/${sessionId}/claim`, {
      guest_token: guestToken,
    });
    return response.data; // { score_pct, is_passed, coupon }
  },

  result: async (sessionId, guestToken = null) => {
    const response = await api.get(`quiz-sessions/${sessionId}`, {
      headers: guestToken ? { "X-Guest-Token": guestToken } : {},
    });
    return response.data;
  },
};

// Köhnə ad ilə istifadə edən yerlər üçün alias
export const QuizSessionService = { create: QuizService.start };
